import { useEffect, useState } from 'react'

import isEmpty from 'lodash/isEmpty'

import i18n from 'modules/core/lib/i18n'

const getTypesLabel = (type: string) => {
  switch (type) {
    case 'medical_confirmation':
      return i18n.t('time_off.medical_leave.updates.types.medical_confirmation')
    case 'medical_discharge':
      return i18n.t('time_off.medical_leave.updates.types.medical_discharge')
    case 'medical_hospital_stay':
      return i18n.t('time_off.medical_leave.updates.types.medical_hospital_stay')
    case 'medical_leave_start':
      return i18n.t('time_off.medical_leave.updates.types.medical_leave_start')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

interface Props {
  leaveTypeValue: string
}
interface ReturnType {
  title: string
  description: string
}

const useCopies = ({ leaveTypeValue }: Props): ReturnType => {
  const [copies, setCopies] = useState({
    title: '',
    description: '',
  })
  useEffect(() => {
    if (isEmpty(leaveTypeValue)) return

    const type = getTypesLabel(leaveTypeValue ?? '')
    setCopies({
      title: i18n.t('time_off.medical_leave.updates.title_modal'),
      description: i18n.t('time_off.medical_leave.updates.new_modal.description', {
        type,
      }),
    })
  }, [leaveTypeValue])

  return copies
}

export default useCopies
